import React from 'react';
import {Button, Modal} from 'react-bootstrap';

export const ConfirmationDialog = (props) => {

    const {
        Body = null,
        CancelButtonMessage:closeButtonMessage = "No",
        ConfirmationButtonMessage:confirmationButtonMessage = "Yes",
        CustomButtonMessage:customButtonMessage = "Custom",
        DeleteButtonMessage:deleteButtonMessage = "Delete",
        DialogDescription = null,
        DisableCloseButton = null,
        DisableConfirmationButton = null,
        DisableCustomButton = null,
        DisableDeleteButton = null,
        Display = true,
        OnClose: onClose = null,
        OnConfirm: onConfirm = null,
        OnCustom: onCustom = null,
        OnDelete: onDelete = null,
        OnHide: onHide = null,
        Title = null,
        children,
        className = null,
        size
    } = props;

    return <Modal
        size={size ?? null}
        show={!!Display}
        backdropClassName="pndlm-modal-backdrop"
        dialogClassName={className}
        onHide={onHide}
    >
        {
            !!Title ?
                <Modal.Header>
                    <Modal.Title>{Title}</Modal.Title>
                </Modal.Header>:
                null
        }

        <Modal.Body>{Body || children}</Modal.Body>

        <Modal.Footer className="dialog-footer">
            <div key={'description'} className="dialog-descr">{ DialogDescription }</div>
            <div key={'buttons'} className="dialog-buttons">
                <div key={'left'} className="dialog-buttons-left">
                    {
                        onCustom ?
                            <Button
                                key={'custom'}
                                variant="outline-secondary"
                                onClick={onCustom}
                                disabled={DisableCustomButton}
                                title={DisableCustomButton}
                            >
                                {customButtonMessage}
                            </Button>:
                            null
                    }
                </div>
                <div key={'right'} className="dialog-buttons-right">
                    {
                        onDelete ?
                            <Button
                                key={'delete'}
                                variant="danger"
                                onClick={onDelete}
                                disabled={DisableDeleteButton}
                                title={DisableDeleteButton}
                            >
                                {deleteButtonMessage}
                            </Button>:
                            null
                    }
                    {
                        (onClose || (onHide && closeButtonMessage)) ?
                            <Button
                                key={'close'}
                                variant="outline-secondary"
                                onClick={onClose ?? onHide}
                                disabled={DisableCloseButton}
                                title={DisableCloseButton}
                            >
                                {closeButtonMessage}
                            </Button>:
                            null
                    }
                    {
                        onConfirm ?
                            <Button
                                key={'primary'}
                                variant="primary"
                                onClick={onConfirm}
                                disabled={DisableConfirmationButton}
                                title={DisableConfirmationButton || null}
                            >
                                {confirmationButtonMessage}
                            </Button>:
                            null
                    }
                </div>
            </div>
        </Modal.Footer>
    </Modal>;

}
